const setThemeFormData = (data) => {
    const { title, textStyles, boxStyles, colors, background, ...props } = data;

    const {
        heading1 = null,
        heading2 = null,
        heading3 = null,
        button = null,
        text = null,
        cta = null,
        badge = null,
    } = textStyles || {};

    const { primary: colorsPrimary = null, secondary: colorsSecondary = null } = colors || {};

    const { color: backgroundColor = null, image: backgroundImage = null } = background || {};

    const { cta: ctaButton = null, badge: badgeButton = null } = boxStyles || {};

    return {
        title,
        heading1,
        heading2,
        heading3,
        button,
        text,
        colorsPrimary,
        colorsSecondary,
        backgroundColor,
        backgroundImage,
        ctaText: cta,
        ctaButton,
        badgeText: badge,
        badgeButton,
        ...props,
    };
};

export default setThemeFormData;
